import { Command } from '@ckeditor/ckeditor5-core'
import replaceContentTags from '@/system/helpers/replaceContentTags.js';

export default class InsertTemplatesCommand extends Command {
    execute({ value }) {
        const editor = this.editor;
        const templatesConfig = editor.config.get('templatesConfig') || {};
        const tagReplacements = templatesConfig.tagReplacements || {};

        let content = value.content;
        content = replaceContentTags(content, tagReplacements);

        if (!content) {
            return;
        }

        editor.model.change(() => {
            const viewFragment = editor.data.processor.toView(content);
            const modelFragment = editor.data.toModel(viewFragment);
            editor.model.insertContent(modelFragment);
        });
    }

    refresh() {
        const templatesConfig = this.editor.config.get('templatesConfig') || {};
        const templates = templatesConfig.types || [];
        this.isEnabled = templates.length > 0;
    }
}
